import { derived, Readable, Writable, writable } from 'svelte/store';
import { getAppConfig } from '../../../common/config/app-config';
import { checkForMegaSaleProduct, getLabelColor, getStr, mergeObjectsBySimilarProperties } from '../../../common/util';

export { openRestockablePopup, restockableProductContent } from '../../../common/store/ui-state-store';

export const pdpData = writable({ name: '' });
export const showAddToCartPopup = writable(false);
export const productImages = writable([]);
export const showPdpTileInfo = writable(false); // todo: remove this var
export const showPdpMoreInfoModal = writable(false);
export const pdpMoreInfoActiveTab = writable('Discover');
export const flixMediaDataAvailable = writable(false);
export const isTTL24DataAvailable = writable(false);
export const flixMediaDataAvailabilityChecked = writable(false);
export const giftCardAmount = writable(0);
export const tasheelPrice = writable(0);

export const productDetails = writable<any>(null);
export const pageLabels = writable([]);
export const currentLocation = writable({});
export const nearestPickupStore = writable(null);
export const showHighlightDetailsPopup = writable(false);
export const hightlightDetailsClickOnSlideIndex = writable(0);
export const selectedGifts = writable([]);
export const selectedGiftGroup = writable(-1);
export const selectedFrequentProds = writable([]);
export const giftPopupForCart = writable(false);
export const shouldPDPGiftOptionReset = writable(false);
export const giftSelectedForCart = writable(false);
export const addToCartContent = writable(null);
export const snackbarLabel = writable('');
export const openSnackbar = writable(false);
export const openExtraDrawer = writable(false);
export const currentSelectedStoreData = writable(null);
export const tasheelConsumerInfo = writable(null);
export const openAddToCartDrawer = writable(false);
export const rsaBrand = writable('');
export const rsaYear = writable('');
export const rsaPlateNo = writable<string>('');
export const selectedServices = writable([]);
export const qacProductCode = writable(null);
export const imgMagnifier = writable({
  imgHeight: 0,
  imgTop: 0,
  imgLeft: 0,
  imgWidth: 0,
  clientX: 0,
  clientY: 0,
  clientWidth: 0,
  clientHeight: 0,
});
export const imageHoverStart = writable(false);
export const currentProductImage = writable('');
export const activateImageZoom = writable(false);
export const showOtherSellerModal = writable(false);
export const giftvalidemail = writable(false);
export const giftcardemail = writable('');
export const giftcardmsg = writable('');
export const isReviewAvailable = writable(false);
export const prodReviewFlag = writable(true);
export const customerReviews = writable([]);
export const extraReviews = writable([]);
export const expertReviews = writable([]);
export const reviewNextPageUrls = writable({
  user: '',
  pro: '',
  your: '',
});
export const reviewGalleryState = writable({
  open: false,
  images: [],
  activeIndex: 0,
});
export const totalReviewsMixPanel = writable(5);
export const ratingMixPanel = writable(4);
export const frequentlyBoughtProducts = writable([]);
export const frequentlyBoughtAlternativeProducts = writable([]);
export const alreadyFetchedBundleData = writable([]);
export const altBundleObj = writable({});
export const tabbyPrice = writable(0);
export const pdpSplitAcServiceSelectedItem = writable(null);
export const pdpSafeguardServiceSelectedItem = writable(null);
export const pdpSetupServiceSelectedItem = writable(null);
export const pdpCareCoatingServiceSelectedItem = writable(null);
export const pdpCareServiceSelectedItem = writable(null);
// mixpanel related stores
export const pdpSafeguardServiceMixpanelData = writable(null);
export const pdpSplitAcServiceMixpanelData = writable(null);
export const pdpSetupServiceMixpanelData = writable(null);
export const pdpAppleCarePlusServiceSelectedItem = writable(null);
export const qacAtcPopupFlag = writable(false);
export const servicesInfo = writable(null);
export const openServicesInfoPopup = writable(false);
export const pdpJoodBenefitInfo = writable(null);
export const openPdpJoodBenefitInfoPopup = writable(false);
export const isReviewSectionExpanded = writable(false);
export const testFreakData = writable(null);
export const showSellerInfo = writable(false);
export const sellerShopData = writable(null);
export const sellerOfferId = writable(null);

const {
  primeEnabled,
  primeLevel,
  isMegaSaleStarted,
  isMegaSaleDuringAccessStarted,
  isMegaSaleDayXStarted,
  pageTemplate,
} = getAppConfig();
// Utility function to get the brand name and color
function getBrandInfo(isDigitalGiftCard, product) {
  const brandName = isDigitalGiftCard ? getStr('digitalGiftCardBrandName') : product?.brandName;

  const brandColor = isDigitalGiftCard ? getLabelColor('digitalGiftCardBrandName') : null;

  return { brandName, brandColor };
}

export function setMixpanelDataForService(
  service_name,
  service_plan_name = undefined,
  service_addon_name = undefined,
  service_fees = undefined,
  service_id = undefined
) {
  let targetStore = null;
  if (service_name === 'Safeguard') {
    targetStore = pdpSafeguardServiceMixpanelData;
  } else if (service_name === 'Setup') {
    targetStore = pdpSetupServiceMixpanelData;
  } else if (service_name === 'Split AC') {
    targetStore = pdpSplitAcServiceMixpanelData;
  }
  if (targetStore) {
    if (service_plan_name === undefined) targetStore.set(null);
    else targetStore.set({ service_name, service_plan_name, service_addon_name, service_fees, service_id });
  }
}

// Derived stores for PDP
export const pdpProductPrice = derived(
  productDetails,
  ($pd, set) => {
    set({
      price: $pd?.discountPrice?.value || $pd?.price?.value,
      basicPrimePrice: $pd?.productBasicPrimeData?.primePrice?.value || 0,
      vipPrimePrice: $pd?.productVipPrimeData?.primePrice?.value || 0,
      wasPrice: $pd?.price?.value,
      priceValueTasheel: $pd?.priceValueTasheel?.value,
      eligibleForTamara: !!$pd?.tamaraDetails,
      eligibleForTabby: $pd?.eligibleForTabby,
      expectedPrimeSaving: $pd?.productVipPrimeData?.expectedPrimeSaving,
      tacticalBasicPromo: !!$pd?.productBasicPrimeData?.tacticalPromo,
      tacticalVipPromo: !!$pd?.productVipPrimeData?.tacticalPromo,
      tacticalVipPrimePrice: $pd?.productVipPrimeData?.tacticalPrice?.value || 0,
      tacticalBasicPrimePrice: $pd?.productBasicPrimeData?.tacticalPrice?.value || 0,
      hasCashBack: !!$pd?.hasCashBack,
      endDateJoodDay: $pd?.endDateJoodDay || null,
      joodDayRemainingQuantity: $pd?.joodDayRemainingQuantity || 0,
      cashback: $pd?.cashBackPrice,
      priceValueDiscountPercentageFlag: !!$pd?.percentageDiscount,
      isComingSoon: $pd?.isComingSoon,
      isDigitalGiftCard: $pd?.isDigitalGiftCard,
      eligibleForFlooss: $pd?.eligibleForFlooss,
      plpEligibleForFlooss: $pd?.plpEligibleForFlooss,
      percentageDiscount: $pd?.percentageDiscount || null,
      basicWalletCredits: $pd?.productBasicPrimeData?.totalPrimeDiscount?.value || 0,
      vipWalletCredits: $pd?.productVipPrimeData?.totalPrimeDiscount?.value || 0,

      smartFirstPrimePrice: $pd?.productSmartPrimeData?.primePrice?.value || 0,
      smartRepeatingPrimePrice: $pd?.productSmartPrimeData?.primePrice?.value || 0,
      tacticalSmartFirstPromo: $pd?.productSmartPrimeData?.tacticalPromo || false,
      tacticalSmartRepeatingPromo: $pd?.productSmartPrimeData?.tacticalPromo || false,
      tacticalSmartFirstPrimePrice: $pd?.productSmartPrimeData?.tacticalPrice?.value || 0,
      tacticalSmartRepeatingPrimePrice: $pd?.productSmartPrimeData?.tacticalPrice?.value || 0,
      smartFirstWalletCredits: $pd?.productSmartPrimeData?.totalPrimeDiscount?.value || 0,
      smartRepeatingWalletCredits: $pd?.productSmartPrimeData?.totalPrimeDiscount?.value || 0,
    });
  },
  null
);

export const pdpGiftCardPriceData = derived(productDetails, ($pd, set) => {
  set({
    tasheelImageUrl: $pd?.tasheelImageUrl,
    tahsheelPaymentAttributes: $pd?.tahsheelPaymentAttributes,
    digitalGiftcardType: $pd?.digitalGiftcardType,
    attributeLabels: $pd?.attributeLabels,
    giftCardPriceDenominations: $pd?.giftCardPriceDenominations,
    minGiftCardAmount: $pd?.minGiftCardAmount,
    maxGiftCardAmount: $pd?.maxGiftCardAmount,
  });
});

export const pdpInstalmentCardData = derived(
  productDetails,
  ($pd, set) => {
    const {
      bnplTabbyPaymentModeEnabled,
      bnplTamaraPaymentModeEnabled,
      bnplBaseetaPaymentModeEnabled,
      bnplFloossPaymentModeEnabled,
    } = getAppConfig();
    const obj = {
      baseeta: null,
      tamara: null,
      flooss: null,
      tabby: null,
      easyPaymentDetails: null,
      qpay: null,
    };

    if ($pd?.tamaraDetails && bnplTamaraPaymentModeEnabled) {
      obj.tamara = {
        ...$pd.tamaraDetails,
      };
    }
    if ($pd?.priceValueTasheel && bnplBaseetaPaymentModeEnabled) {
      obj.baseeta = {
        priceValue: $pd?.priceValueTasheel?.value,
        tasheelInstallmentMonths: window['ACC'].config.unbxdSearchConfig.tasheelInfo.tasheelInstallmentMonths,
        tasheelContentUrl: window['ACC'].config.unbxdSearchConfig.tasheelInfo.tasheelContentUrl,
      };
    }
    if (bnplFloossPaymentModeEnabled && $pd?.eligibleForFlooss && $pd?.floossDetails) {
      obj.flooss = {
        ...$pd.floossDetails,
      };
    }
    if ($pd?.tabbyDetails && bnplTabbyPaymentModeEnabled) {
      obj.tabby = {
        ...$pd?.tabbyDetails,
      };
    }
    if ($pd?.easyPaymentDetails) {
      obj.easyPaymentDetails = {
        ...$pd?.easyPaymentDetails,
      };
    }

    if ($pd?.qpayDetails) {
      obj.qpay = {
        ...$pd?.qpayDetails,
      };
    }

    set(obj);
  },
  {
    baseeta: null,
    tamara: null,
    tabby: null,
    easyPaymentDetails: null,
  }
);

export const pdpOfferCardData = derived(
  productDetails,
  ($pd, set) => {
    let allValidPromotions = [];
    if ($pd?.bankPromotionDetails?.length > 0) {
      allValidPromotions = $pd.bankPromotionDetails.filter(x => x?.bankHtmlMessage?.length > 0);
    }
    const obj = {
      freeGiftDataList: $pd?.freeGiftNotAvailable
        ? $pd?.freeGiftDataList?.length === 1 && $pd?.freeGiftDataList?.acPriceDiscountValue !== null
          ? $pd?.freeGiftDataList
          : $pd?.freeGiftNotAvailableMessage
        : $pd?.freeGiftDataList?.length > 0
          ? $pd?.freeGiftDataList
          : null,
      couponData: $pd?.couponData,
      bankPromotionDetails: allValidPromotions.length > 0 ? allValidPromotions : null,
    };
    set(obj);
  },
  {
    freeGiftDataList: null,
    couponData: null,
    bankPromotionDetails: null,
  }
);

export const pdpDeliveryOptionCardData = derived(productDetails, ($pd, set) => {
  const isTransactional = window['ACC'].config.isTransactional;

  set({
    onDemandDeliveryMode: $pd?.onDemandDeliveryMode,
    stock: $pd?.stock,
    isTransactional,
    productStatus: $pd?.productStatus,
    isCollectFromStoreEnabled: $pd?.isCollectFromStoreEnabled,
    cfsPosPickUpInStoreData: $pd?.cfsPosPickUpInStoreData,
    homeDeliveryData: $pd?.homeDeliveryData,
    deliveryLeadTimeNow: $pd?.deliveryLeadTimeNow,
    deliveryLeadTimeBeforeBy: $pd?.deliveryLeadTimeBeforeBy,
    displayFreeDelivery: $pd?.displayFreeDelivery,
    deliveryPayment: $pd?.deliveryPayment,
    expressDeliveryMode: $pd?.expressDeliveryMode,
    code: $pd?.code,
    isHomeDeliveryEnabled: $pd?.isHomeDeliveryEnabled,
    shippingClassification: $pd?.shippingClassification,
    standardDeliveryCost: $pd?.standardDeliveryCost,
    deliveryLeadTimeBefore: $pd?.deliveryLeadTimeBefore,
    deliveryLeadMessage: $pd?.deliveryLeadMessage,
    isDigitalGiftCard: $pd?.isDigitalGiftCard,
    digitalDeliveryItem: $pd?.digitalDeliveryItem,
    cfsBackOrderEligible: $pd?.cfsBackOrderEligible,
    cfsBackOrderLaunchDate: $pd?.cfsBackOrderLaunchDate,
    isComingSoon: $pd?.isComingSoon,
  });
});

export const pdpProductExtraLinksData = derived(productDetails, ($pd, set) => {
  const isSKUInStock = $pd?.stock?.stockLevelStatus?.code !== 'outOfStock';

  set({
    isSKUInStock,
    productIconLabelContents: $pd?.productIconLabelContents,
    warranty: $pd?.warranty,
    warrantyDuration: $pd?.warrantyDuration,
  });
});

export const pdpServiceCardData = derived<Writable<any>, any>(productDetails, ($pd, set) => {
  set({
    eligibleVasEntries: $pd?.eligibleVasEntries?.length ? $pd?.eligibleVasEntries : [],
    servicesBlocks: $pd?.servicesBlocks,
    lmdConfigurations: $pd?.lmdConfigurations,
    appleCarePlusVasEntries: $pd?.eligibleVasEntries?.length
      ? $pd?.eligibleVasEntries.filter(vasEntry => vasEntry.vasGroup === 'ACC')
      : [],
  });
});

export const pdpServicesData: Readable<any> = derived(
  [
    pdpSafeguardServiceSelectedItem,
    pdpSetupServiceSelectedItem,
    pdpCareServiceSelectedItem,
    pdpAppleCarePlusServiceSelectedItem,
    pdpCareCoatingServiceSelectedItem,
    pdpSplitAcServiceSelectedItem,
  ],
  ($services, set) => {
    set($services.filter(s => !!s));
  }
);

export const pdpCashbackCardData = derived(productDetails, ($pd, set) => {
  set({
    aftreCashBackPrice: $pd?.aftreCashBackPrice?.value,
    cashBackPrice: $pd?.cashBackPrice,
  });
});

export const pdpServicesMixpanelData = derived(
  // order of items defines the priority of services
  [pdpSafeguardServiceMixpanelData, pdpSetupServiceMixpanelData, pdpSplitAcServiceMixpanelData],
  ($serviceMPData, set) => {
    const nonNullServiceMPData = $serviceMPData.filter(x => !!x);
    if (nonNullServiceMPData.length > 0) {
      const mergedServiceMPData = mergeObjectsBySimilarProperties(nonNullServiceMPData);
      set(mergedServiceMPData);
    } else {
      set(null);
    }
  }
);

export const pdpServicesGtmData = derived(
  // order of items defines the priority of services
  [pdpSafeguardServiceMixpanelData, pdpSetupServiceMixpanelData, pdpSplitAcServiceMixpanelData],
  ($serviceMPData, set) => {
    const nonNullServiceMPData = $serviceMPData.filter(x => !!x);
    if (nonNullServiceMPData.length > 0) {
      set(nonNullServiceMPData);
    } else {
      set(null);
    }
  }
);

export const pdpServicesSaveStateStore = function () {
  const defaultState = {
    safeguard: null,
    setup: null,
    careCoating: null,
    care: null,
    acSetup: null,
  };

  const { subscribe, set, update } = writable(defaultState);

  return {
    subscribe,
    clearAllServicesState: () => set(defaultState),
    setSafeguard: (activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected) => {
      let safeguard = null;
      if (!!activeAddonVasPrice || !!activeBaseVasPrice) {
        safeguard = { activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected };
      }
      update(state => Object.assign({}, state, { safeguard }));
    },
    setSetup: (activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected) => {
      let setup = null;
      if (!!activeAddonVasPrice || !!activeBaseVasPrice) {
        setup = { activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected };
      }
      update(state => Object.assign({}, state, { setup }));
    },
    setCareCoating: (activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected) => {
      let careCoating = null;
      if (!!activeAddonVasPrice || !!activeBaseVasPrice) {
        careCoating = { activeBaseVasPrice, activeAddonVasPrice, isNoPlanOptionSelected };
      }
      update(state => Object.assign({}, state, { careCoating }));
    },
    setCare: (activeTabIndex, activeTabSelectedOptionIndex, activeTabChildSelected) => {
      let care = null;
      if (activeTabSelectedOptionIndex > -1) {
        care = { activeTabIndex, activeTabSelectedOptionIndex, activeTabChildSelected };
      }
      update(state => Object.assign({}, state, { care }));
    },
    setAcSetup: activeSetupOption => {
      let acSetup = null;
      if (activeSetupOption) {
        acSetup = { activeSetupOption };
      }
      update(state => Object.assign({}, state, { acSetup }));
    },
  };
};

export const pdpTitleData = derived(productDetails, ($pd, set) => {
  const isDigitalGiftCard = $pd?.isDigitalGiftCard;

  const { brandName, brandColor } = getBrandInfo(isDigitalGiftCard, $pd);
  set({
    brandName,
    brandNameEn: $pd?.brandNameEn,
    name: $pd?.name,
    brandColor,
    isSponsored: $pd?.sponsoredType != null,
    shopMoreDetails: $pd?.shopMoreDetails,
    marketPlaceOfferConditionCode: $pd?.marketPlaceOfferData?.conditionCode,
  });
});

export const productImagesData = derived(productDetails, ($pd, set) => {
  if (!$pd) {
    return;
  }
  set({
    code: $pd?.code,
    productTags: pageTemplate === 'extraPreOrderLandingPageTemplate' ? $pd?.preOrderTags : $pd?.productTags,
    extraProductGalleryTiles: $pd?.extraProductGalleryTiles,
    keyHighlights: $pd?.keyHighlights,
    name: $pd?.name,
  });
});

export const pdpExtraDrawerData = derived(productDetails, ($pd, set) => {
  const isDigitalGiftCard = $pd?.isDigitalGiftCard;
  const { brandName, brandColor } = getBrandInfo(isDigitalGiftCard, $pd);
  set({
    brandName,
    name: $pd?.name,
    brandColor,
    amplienceProductBaseUrl: $pd?.amplienceProductBaseUrl,
    price: $pd?.price,
    discountPrice: $pd?.discountPrice,
    tasheelPriceValuesList: $pd?.tasheelPriceValuesList ? $pd?.tasheelPriceValuesList : null,
  });
});

export const prodUnavailableData = derived(productDetails, ($pd, set) => {
  set({
    isComingSoon: $pd?.isComingSoon,
    comingSoonDate: $pd?.comingSoonDate,
    code: $pd?.code,
    price: $pd?.price,
    nameEn: $pd?.nameEn,
  });
});

export const addToCartData = derived(productDetails, ($pd, set) => {
  const vipTacticalPromo = $pd?.productVipPrimeData?.tacticalPromo || false;
  const basicTacticalPromo = $pd?.productBasicPrimeData?.tacticalPromo || false;
  const vipTacticalPrice = $pd?.productVipPrimeData?.tacticalPrice?.formattedValue;
  const basicTacticalPrice = $pd?.productBasicPrimeData?.tacticalPrice?.formattedValue;
  set({
    primeEnabled: primeEnabled ? primeEnabled : null,
    primeLevel: primeLevel ? primeLevel : null,
    vipPrimePrice: $pd?.productVipPrimeData?.primePrice?.formattedValue
      ? $pd?.productVipPrimeData?.primePrice?.formattedValue
      : null,
    basicPrimePrice: $pd?.productBasicPrimeData?.primePrice?.formattedValue
      ? $pd?.productBasicPrimeData?.primePrice?.formattedValue
      : null,
    productCode: $pd?.code,
    isJoodDay: basicTacticalPromo || vipTacticalPromo,
    joodDayPrice: primeLevel && primeLevel === 'VIPPRIME' ? vipTacticalPrice : basicTacticalPrice,
    price: $pd?.price,
    stock: $pd?.stock,
    productStatus: $pd?.productStatus,
    tasheelPriceValuesList: $pd?.tasheelPriceValuesList ? $pd?.tasheelPriceValuesList : null,
    homeDeliveryData: $pd?.homeDeliveryData,
    isDigitalGiftCard: $pd?.isDigitalGiftCard ? $pd.isDigitalGiftCard : null,
    minGiftCardAmount: $pd?.minGiftCardAmount ? $pd.minGiftCardAmount : null,
    maxGiftCardAmount: $pd?.maxGiftCardAmount ? $pd.maxGiftCardAmount : null,
    digitalDeliveryItem: $pd?.digitalDeliveryItem ? $pd.digitalDeliveryItem : null,
    tahsheelPaymentAttributes: $pd?.tahsheelPaymentAttributes,
    tasheelImageUrl: $pd?.tasheelImageUrl,
    isWishlisted: $pd?.inWhishList ? $pd.inWhishList : false,
    cfsBackOrderEligible: $pd?.cfsBackOrderEligible ? $pd.cfsBackOrderEligible : false,
    cfsBackOrderLaunchDate: $pd?.cfsBackOrderLaunchDate ? $pd.cfsBackOrderLaunchDate : null,
    cfsPosPickUpInStoreData: $pd?.cfsPosPickUpInStoreData,
    isCollectFromStoreEnabled: $pd?.isCollectFromStoreEnabled,
    discountPrice: $pd?.discountPrice,
    isAddToCartGrayedOut: $pd?.isAddToCartGrayedOut ? $pd.isAddToCartGrayedOut : false,
  });
});

export const pdpBundlePromotionData = derived(productDetails, ($pd, set) => {
  const isDigitalGiftCard = $pd?.isDigitalGiftCard;

  const { brandName } = getBrandInfo(isDigitalGiftCard, $pd);
  set({
    code: $pd?.code,
    name: $pd?.name,
    stock: $pd?.stock,
    amplienceProductBaseUrl: $pd?.amplienceProductBaseUrl,
    price: $pd?.price,
    discountPrice: $pd?.discountPrice,
    specialOfferDataList: $pd?.specialOfferDataList,
    brandName,
    tasheelPriceValuesList: $pd?.tasheelPriceValuesList ? $pd?.tasheelPriceValuesList : null,
    percentageDiscount: $pd?.percentageDiscount,
  });
});

export const pdpManualBundleData = derived(productDetails, ($pd, set) => {
  set({
    manualBundleProducts: $pd?.manualBundleProducts,
    code: $pd?.code,
    price: $pd?.price,
    tasheelPriceValuesList: $pd?.tasheelPriceValuesList ? $pd?.tasheelPriceValuesList : null,
  });
});

export const pdpHighlightsAndSpecsData = derived(productDetails, ($pd, set) => {
  set({
    code: $pd?.code,
    modelNumber: $pd?.modelNumber,
    additionalHighlights: $pd?.additionalHighlights,
    productSpecifications: $pd?.productSpecifications,
    groupedfeatures: $pd?.groupedfeatures ? $pd?.groupedfeatures : null,
    description: $pd?.description,
  });
});

export const productTasheelPriceData = derived(productDetails, ($pd, set) => {
  set({
    tasheelImageUrl: $pd?.tasheelImageUrl,
    tahsheelPaymentAttributes: $pd?.tahsheelPaymentAttributes,
  });
});

export const joodPrimePriceData = derived(productDetails, ($pd, set) => {
  const vipTacticalPromo = $pd?.productVipPrimeData?.tacticalPromo || false;
  const basicTacticalPromo = $pd?.productBasicPrimeData?.tacticalPromo || false;
  const smartTacticalPromo = $pd?.productSmartPrimeData?.tacticalPromo || false;
  const vipTacticalPrice = $pd?.productVipPrimeData?.tacticalPrice?.formattedValue;
  const basicTacticalPrice = $pd?.productBasicPrimeData?.tacticalPrice?.formattedValue;
  const smartTacticalPrice = $pd?.productSmartPrimeData?.tacticalPrice?.formattedValue;

  // Determine tactical promo and price according to current primeLevel
  const level = primeLevel || 'VIPPRIME';
  let levelTacticalPromo = false;
  let levelTacticalPrice: string | null = null;
  if (level === 'VIPPRIME') {
    levelTacticalPromo = vipTacticalPromo;
    levelTacticalPrice = vipTacticalPrice || null;
  } else if (level === 'SMARTPRIME') {
    levelTacticalPromo = smartTacticalPromo;
    levelTacticalPrice = smartTacticalPrice || null;
  } else {
    levelTacticalPromo = basicTacticalPromo;
    levelTacticalPrice = basicTacticalPrice || null;
  }

  set({
    vipPrimePrice: $pd?.productVipPrimeData?.primePrice?.formattedValue
      ? $pd?.productVipPrimeData?.primePrice?.formattedValue
      : null,
    basicPrimePrice: $pd?.productBasicPrimeData?.primePrice?.formattedValue
      ? $pd?.productBasicPrimeData?.primePrice?.formattedValue
      : null,
    smartPrimePrice: $pd?.productSmartPrimeData?.primePrice?.formattedValue
      ? $pd?.productSmartPrimeData?.primePrice?.formattedValue
      : null,
    discountPrice: $pd?.discountPrice,
    // isJoodDay and joodDayPrice respect the current primeLevel
    isJoodDay: !!levelTacticalPromo,
    joodDayPrice: levelTacticalPrice,
  });
});

export const productPriceData = derived(productDetails, ($pd, set) => {
  set({
    discountPrice: $pd?.discountPrice,
    percentageDiscount: $pd?.percentageDiscount,
    price: $pd?.price,
    savingAmount: $pd?.savingAmount,
    tasheelImageUrl: $pd?.tasheelImageUrl,
    tasheelPriceValuesList: $pd?.tasheelPriceValuesList ? $pd?.tasheelPriceValuesList : null,
    offersLabel: $pd?.offersLabel,
  });
});

export const pdpHighlightPopupData = derived(productDetails, ($pd, set) => {
  const tasheelPriceValuesList = $pd?.tasheelPriceValuesList;
  const currentTasheelPriceValue =
    (tasheelPriceValuesList && tasheelPriceValuesList.length > 0 && tasheelPriceValuesList[0]) || null;
  const discountPrice = $pd?.discountPrice;
  const price = $pd?.price;
  set({
    keyHighlights: $pd?.keyHighlights,
    amplienceProductBaseUrl: $pd?.amplienceProductBaseUrl,
    tasheelImageUrl: $pd?.tasheelImageUrl,
    price,
    currency: $pd?.price?.currencyIso,
    discountPrice,
    savingAmount: $pd?.savingAmount,
    percentageDiscount: $pd?.percentageDiscount,
    tasheelPriceValuesList,
    currentTasheelPriceValue,
    tasheelPrice: currentTasheelPriceValue && currentTasheelPriceValue.priceValueTasheel.formattedValue,
    tasheelInstallMonths: window['ACC'].config.unbxdSearchConfig.tasheelInfo.tasheelInstallmentMonths,
    tasheelPercentage: currentTasheelPriceValue && currentTasheelPriceValue.tasheelPercentage,
    hasDiscount: discountPrice !== null,
    productSellingPrice: discountPrice === null ? price?.formattedValue : discountPrice?.formattedValue,
  });
});

export const pdpSpecsAndStickyBarData = derived(productDetails, ($pd, set) => {
  const stock = $pd?.stock;
  const homeDeliveryData = $pd?.homeDeliveryData;
  set({
    name: $pd?.name,
    brandName: $pd?.brandName,
    brandNameEn: $pd?.brandNameEn,
    highlights: $pd?.highlights,
    description: $pd?.description,
    productSpecifications: $pd?.productSpecifications,
    stock,
    amplienceProductBaseUrl: $pd?.amplienceProductBaseUrl,
    groupedfeatures: $pd?.groupedfeatures,
    homeDeliveryData: $pd?.homeDeliveryData,
    isAddToCartEnabled: $pd?.isAddToCartEnabled,
    stockStatus: stock?.stockLevelStatus?.code === 'inStock' || stock?.stockLevelStatus?.code === 'lowStock',
    deliveryInStock:
      homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'inStock' ||
      homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'lowStock',
    productStatus: $pd?.productStatus,
    isDigitalGiftCard: $pd?.isDigitalGiftCard,
    minGiftCardAmount: $pd?.minGiftCardAmount,
    maxGiftCardAmount: $pd?.maxGiftCardAmount,
    homeDeliverystockOutOfStock: homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code == 'outOfStock',
    highlightsProvider: $pd?.highlightsProvider,
    productCode: $pd?.code,
    modelNumber: $pd?.modelNumber,
    isComingSoon: $pd?.isComingSoon,
    vipPrimePrice: $pd?.productVipPrimeData?.primePrice?.formattedValue
      ? $pd?.productVipPrimeData?.primePrice?.formattedValue
      : null,
    smartPrimePrice: $pd?.productSmartPrimeData?.primePrice?.formattedValue
      ? $pd?.productSmartPrimeData?.primePrice?.formattedValue
      : null,
    basicPrimePrice: $pd?.productBasicPrimeData?.primePrice?.formattedValue
      ? $pd?.productBasicPrimeData?.primePrice?.formattedValue
      : null,
    classifications: $pd?.classifications || null,
  });
});

export const productDetailMainData = derived(
  productDetails,
  ($pd, set) => {
    const isTransactional = window['ACC'].config.isTransactional || true;
    const stockStatus =
      $pd?.stock.stockLevelStatus.code === 'inStock' || $pd?.stock.stockLevelStatus.code === 'lowStock';
    const stock = $pd?.stock;
    const deliveryInStock =
      $pd?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'inStock' ||
      $pd?.homeDeliveryData?.currentCityStockData?.stockLevelStatus?.code === 'lowStock';
    const isMegaSaleProductFlag =
      ($pd?.isJoodMegaSaleProduct && isMegaSaleDayXStarted) ||
      ($pd?.isJoodMegaSaleProduct && isMegaSaleDuringAccessStarted) ||
      (isMegaSaleStarted && $pd?.isJoodMegaSaleProduct);
    set({
      name: $pd?.name,
      productTags: $pd?.productTags,
      code: $pd?.code,
      keyHighlights: $pd?.keyHighlights,
      extraProductGalleryTiles: $pd?.extraProductGalleryTiles,
      productVariantGroups: $pd?.productVariantGroups,
      cfsPosPickUpInStoreData: $pd?.cfsPosPickUpInStoreData,
      homeDeliveryData: $pd?.homeDeliveryData,
      productStatus: $pd?.productStatus,
      stock,
      isComingSoon: $pd?.isComingSoon,
      comingSoonDate: $pd?.comingSoonDate,
      comingSoonTimerDate: $pd?.comingSoonTimerDate,
      specialOfferDataList: $pd?.specialOfferDataList,
      isDigitalGiftCard: $pd?.isDigitalGiftCard,
      digitalDeliveryItem: $pd?.digitalDeliveryItem,
      manualBundleProducts: $pd?.manualBundleProducts,
      minGiftCardAmount: $pd?.minGiftCardAmount,
      maxGiftCardAmount: $pd?.maxGiftCardAmount,
      freeGiftDataList: $pd?.freeGiftNotAvailable
        ? $pd?.freeGiftDataList?.length === 1 && $pd?.freeGiftDataList?.acPriceDiscountValue !== null
          ? $pd?.freeGiftDataList
          : $pd?.freeGiftNotAvailableMessage
        : $pd?.freeGiftDataList?.length > 0
          ? $pd?.freeGiftDataList
          : null,
      hasFreeGift: $pd?.hasFreeGift,
      isTransactional,
      isRSAItem: $pd?.isRSAItem,
      brands: $pd?.brands,
      isAddToCartEnabled: $pd?.isAddToCartEnabled,
      liveStreamAvailable: $pd?.liveStreamAvailable,
      shopMoreDetails: $pd?.shopMoreDetails,
      basketPromotions: $pd?.basketPromotions,
      isMarketPlaceProduct: $pd?.marketPlaceProduct,
      stockStatus,
      deliveryInStock,
      isMegaSaleProductFlag,
      endDateDeal: $pd?.endDateDeal,
      isMegaSaleThemedProduct: checkForMegaSaleProduct($pd?.productTags),
      amplienceProductBaseUrl: $pd?.amplienceProductBaseUrl,
      isReStockable: $pd?.isReStockable,
      hidePriceForComingSoon: $pd?.hidePriceForComingSoon,
    });
  },
  null
);

export const pdpServicesSaveState = pdpServicesSaveStateStore();

export const pdpSellerInfoData: any = derived(productDetails, ($pd, set) => {
  set({
    marketPlaceOfferData: $pd?.marketPlaceOfferData,
    marketPlaceProduct: $pd?.marketPlaceProduct,
    marketPlaceShopDetails: $pd?.marketPlaceShopDetails,
    marketPlaceOffersByCondition: $pd?.marketPlaceOffersByCondition,
    otherSellersCount: $pd?.otherSellersCount,
    otherSellersLowestPrice: $pd?.otherSellersLowestPrice?.value,
  });
});
function productQuantityCRUD(minQuantity: number, maxQuantity: number) {
  const store = writable<number>(minQuantity);
  const isAtMin = derived<typeof store, boolean>(store, ($s, set) => {
    set($s === minQuantity);
  });
  const isAtMax = derived<typeof store, boolean>(store, ($s, set) => {
    set($s === maxQuantity);
  });

  const { set, update, subscribe } = store;
  return {
    subscribe,
    isAtMax,
    isAtMin,
    updateQuantity: (qty: number | string) => {
      const n: number = typeof qty === 'string' ? +qty : qty;
      set(0);
      if (n < minQuantity) set(minQuantity);
      else if (n > maxQuantity) set(maxQuantity);
      else set(n);
    },
    increment: () => {
      update(n => {
        if (n < maxQuantity) return n + 1;
        return n;
      });
    },
    decrement: () => {
      update(n => {
        if (n > minQuantity) return n - 1;
        return n;
      });
    },
  };
}

const minQty = getAppConfig().productDetails?.marketPlaceProduct
  ? getAppConfig().productDetails?.marketPlaceOfferData.minOrderQuantity
  : getAppConfig().productDetails?.minOrderQuantity;
const maxQty = getAppConfig().productDetails?.marketPlaceProduct
  ? getAppConfig().productDetails?.marketPlaceOfferData.maxOrderQuantity
  : getAppConfig().productDetails?.maxOrderQuantity;

export const productQuantity = productQuantityCRUD(minQty || 1, maxQty || 99);

export const { isAtMax, isAtMin } = productQuantity;

export const pdpCollectionPointData = derived(productDetails, $pd => $pd?.collectionPointData);
